/**
 * @module Utilities/Helpers
 * @desc Helpers helper funtions
 */

/**
 * Get search params from url
 */
export function getSearchParams() {
  const { search } = window.location;

  return new URLSearchParams(search);
}
